<template>
	<router-view />
	<AgentButton
		v-if="enableAgent"
		:languageCode="locale"
	/>
	<ReportButton
		v-if="enableReport"
		:languageCode="locale"
	/>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useLocale } from '@deepidoo/deesplay-shared/composables';

import AgentButton from './agent/components/agentButton/AgentButton.vue';
import ReportButton from './report/components/reportButton/ReportButton.vue';

const { locale } = useLocale();

const enableAgent = computed(() => {
	return import.meta.env.VITE_ENABLE_AGENT === 'true';
});

const enableReport = computed(() => {
	return import.meta.env.VITE_ENABLE_REPORT === 'true';
});
</script>
